import { ImpactAssessment } from './impact-assessment';
import { ImpactAssessment4 } from './impact-assessment4';
import { ImpactAssessmentT5 } from './impact-assessmentT5';
export class BulkUpdateModel {
  itemIds: Array<number>;
  impactAssessment: ImpactAssessment;

  constructor() {
    this.itemIds = [];
    this.impactAssessment = new ImpactAssessment();
  }
}


